import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'helpers/redux/form';
import { PropTypes } from 'helpers/react';
const { func, objectOf, string, shape, number } = PropTypes;

import styles from '../styles/index.scss';
import withAppConfig from 'shared-components/withAppConfig';
import { Container, Row, Col } from 'shared-components/grid';
import HelpText from 'shared-components/HelpText';
import ImageUploadInputField from 'shared-components/formFields/ImageUploadInputField';
import DocumentationLink from 'shared-components/DocumentationLink';

@reduxForm({
  form: 'application-wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})
@withAppConfig
export default class ApplicationDetailsPage extends React.Component {
  static propTypes = {
    error: string,
    fields: objectOf(string).isRequired,
    onSubmit: func.isRequired,
    appConfig: shape({
      filePickerApiKey: string.isRequired
    }).isRequired,
    descriptionLength: number
  };
  static defaultProps = {};

  render() {
    const { fields } = this.props;
    return (
      <Container>
        <Row className={styles['helpTextContainer']}>
          <Col lg={12}>
            <HelpText>
              Need help? Check out&nbsp;
              <DocumentationLink src="https://docs.veritone.com/#/applications/">
                Submitting an application
              </DocumentationLink>
            </HelpText>
          </Col>
        </Row>
        <Row className={styles['formContainer']}>
          <Col lg={2} className={styles['imgUploadField']}>
            <ImageUploadInputField
              name={fields.iconUrl}
              title={
                <span>
                  Icon (<em>Optional</em>)
                </span>
              }
              labelClassName={styles['fieldLabel']}
              height={128}
              width={128}
              pickerWidth={128}
              filePickerApiKey={this.props.appConfig.filePickerApiKey}
            />
          </Col>
          <Col lg={7}>
            <Field
              label="Application Name"
              name={fields.name}
              className={styles['formField']}
              component={TextField}
              maxLength={50}
            />
            <Field
              label="Application Description (Optional)"
              name={fields.description}
              type="text"
              maxLength={250}
              multiLine
              rows={3}
              rowsMax={5}
              className={styles['formField']}
              component={TextField}
            />
            <Field
              label="URL"
              type="url"
              name={fields.url}
              className={styles['formField']}
              component={TextField}
              hintText="https://"
            />

            <Field
              label="OAuth2 Redirect URL"
              type="url"
              name={fields.oauth2RedirectUrls}
              className={styles['formField']}
              component={TextField}
              hintText="https://"
            />
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/pages/application-wizard/pages/application-details/components/ApplicationDetailsPage.js